import { ValidationTextFieldProps } from '../../ValidationTextField';

export type ModalTextInputProps = {
  inputProps: ValidationTextFieldProps;
  label?: string;
  testId?: string;
};

export { default as ModalTextInput } from './ModalTextInput';
